var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 54,
    viewBox: "0 0 52 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.091,
    y1: 0.932,
    x2: 0.928,
    y2: 0.049,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff0100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d800b9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(-1709 -4217)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(1709.134 4216.933)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_221",
    "data-name": "Rectangle 221",
    width: 52,
    height: 54,
    rx: 5,
    transform: "translate(-0.134 0.067)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "instagram_1_",
    "data-name": "instagram (1)",
    transform: "translate(1718.646 4226.644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M32.611,9.612a12.007,12.007,0,0,0-.76-3.97,8.016,8.016,0,0,0-1.886-2.9,8.018,8.018,0,0,0-2.9-1.887A12,12,0,0,0,23.1.1C21.353.019,20.8,0,16.355,0s-5,.019-6.743.1a12.008,12.008,0,0,0-3.97.76,8.016,8.016,0,0,0-2.9,1.886,8.017,8.017,0,0,0-1.887,2.9A12.006,12.006,0,0,0,.1,9.611c-.08,1.744-.1,2.3-.1,6.743s.019,5,.1,6.743a12,12,0,0,0,.76,3.97,8.015,8.015,0,0,0,1.886,2.9,8.013,8.013,0,0,0,2.9,1.886,12,12,0,0,0,3.97.76c1.744.08,2.3.1,6.743.1s5-.019,6.743-.1a12,12,0,0,0,3.97-.76,8.361,8.361,0,0,0,4.783-4.783,12,12,0,0,0,.76-3.97c.079-1.744.1-2.3.1-6.743s-.019-5-.1-6.743ZM29.667,22.964A9.049,9.049,0,0,1,29.1,26,5.416,5.416,0,0,1,26,29.1a9.049,9.049,0,0,1-3.037.563c-1.724.079-2.241.1-6.609.1s-4.885-.016-6.609-.1A9.052,9.052,0,0,1,6.709,29.1a5.068,5.068,0,0,1-1.88-1.224A5.066,5.066,0,0,1,3.6,26a9.049,9.049,0,0,1-.563-3.037c-.079-1.724-.1-2.242-.1-6.609s.017-4.884.1-6.609A9.055,9.055,0,0,1,3.6,6.709,5.07,5.07,0,0,1,4.828,4.828,5.064,5.064,0,0,1,6.709,3.605a9.047,9.047,0,0,1,3.037-.563c1.724-.079,2.242-.1,6.609-.1h0c4.367,0,4.884.017,6.609.1A9.05,9.05,0,0,1,26,3.605a5.071,5.071,0,0,1,1.88,1.223A5.064,5.064,0,0,1,29.1,6.709a9.041,9.041,0,0,1,.563,3.037c.079,1.724.1,2.242.1,6.609s-.016,4.884-.1,6.609Zm0,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M132.937,124.539a8.4,8.4,0,1,0,8.4,8.4A8.4,8.4,0,0,0,132.937,124.539Zm0,13.85a5.452,5.452,0,1,1,5.452-5.452A5.452,5.452,0,0,1,132.937,138.389Zm0,0",
    transform: "translate(-116.583 -116.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M365.855,90.588a1.963,1.963,0,1,1-1.962-1.963A1.963,1.963,0,0,1,365.855,90.588Zm0,0",
    transform: "translate(-338.808 -82.964)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/InstagramIcon.5563d76ee84322aa7e2ac05996476a54.svg";
export { ForwardRef as ReactComponent };